import React from "react";
import { motion, AnimatePresence } from "framer-motion";

// style
import styles from "./styles.module.scss";

// componenst
import Item from "./Item";

// mockup
import data from "src/utils/data";

const Dropdown = ({ visible, handleCityClick }) => {
  const onCityClick = (_city) => {
    handleCityClick(_city);
  };

  const onVenuClick = (_venue) => {
    alert("Venues in progress!");
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className={styles.dropdown__wrapper}
          onClick={(e) => e.stopPropagation()}
          // initial={{ opacity: 0, scale: 0 }}
          // animate={{ opacity: 1, scale: 1 }}
          initial={{ height: "0" }}
          animate={{ height: "auto" }}
          exit={{ opacity: 0 }}
          transition={{ ease: "easeInOut" }}
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1 }}
            className={styles.event__list}
          >
            <h3>Popular Event destinations</h3>
            <ul>
              {data.event_search.events.map((item, i) => (
                <Item key={i} data={item} handleClick={onCityClick} />
              ))}
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className={styles.venue__list}
          >
            <h3>Venues</h3>
            <ul>
              {data.event_search.venue.map((item, i) => (
                <Item key={i} data={item} icon handleClick={onVenuClick} />
              ))}
            </ul>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Dropdown;
